(function () {
    class LocalAuthenticationStrategy {
        constructor (config) {
   
            this.storageId = "auth";

            app.logging.log("LocalAuthenticationStrategy","LocalAuthenticationStrategy", this.storageId)
        }

        login (options) {


            app.localStore.set(this.storageId, {email: options.email, loggedIn:true})

           // localStorage.setItem(this.storageId, JSON.stringify({email, loggedIn:true}));
            return Promise.resolve();
        }
        logout () {
            // delete local storage entry
            app.localStore.remove(this.storageId);
            return Promise.resolve();
        }
        isAuthenticated () {

            if(!app.localStore.has(this.storageId)) return false;
            const stored = app.localStore.get(this.storageId)
            return stored.loggedIn;
        }

        isAuthorized () {
            return true;
        }
        user () {
            return app.localStore.get(this.storageId);
        }
    }

    AuthenticationProvider.add("LocalAuthenticationStrategy", (config) => {
        app.logging.log("LocalAuthenticationStrategy", "creating new LocalAuthenticationStrategy")
        return new LocalAuthenticationStrategy(config);
    })
}())